import { amplitude } from 'app/utils/analytics/amplitude/client';
import type { HyroxEventName, HyroxEvents } from 'app/utils/analytics/types';

export const trackEvent = <T extends HyroxEventName>(name: T, props: HyroxEvents[T]): void => {
  // Only track if amplitude is available (user has consented to analytics)
  if (amplitude && typeof amplitude.track === 'function') {
    amplitude.track(name, props);
  }
};
